import React, {Component} from "react";
import authorize from "./authorize"
export default (WrappedComponent) => {

    return class extends Component {
        state={
            authorized:false
        }
        constructor(props) {
            super(props)
        }
        componentWillMount() {
            const {authority} = this.props
            if(authority) {
                authorize(authority).then(() => {
                    this.setState({
                        authorized: true
                    })
                }, () => {
                    this.setState({
                        authorized: false
                    })
                })
            }else{
                this.setState({
                    authorized: true
                })
            }
        }
        render() {
            const defaultComponent = null
            return (
                this.state.authorized?
                    <WrappedComponent {...this.props}/>:(defaultComponent?defaultComponent:null)
            )
        }
    }
}